import { matchSorter } from 'match-sorter';

export const usePackageSearch = (
    companyId: MaybeRefOrGetter<number | undefined>,
    exclude?: (id: number) => boolean,
) => {
    const { state, isLoading, execute } = useAsyncState(
        (companyId: number) =>
            companyId == null
                ? Promise.resolve(undefined)
                : api.getPackages({
                      queries: {
                          'filter[company_id]': companyId,
                          'page[size]': 500,
                      },
                  }),
        undefined,
        {
            resetOnExecute: false,
        },
    );

    watch(
        () => toValue(companyId),
        n => {
            if (n) {
                execute(undefined, n);
            }
        },
        {
            immediate: true,
        },
    );
    const packagesFilter = ref<string>();

    const filteredPackages = computed(() => {
        const result =
            matchSorter(state.value?.data ?? [], packagesFilter.value ?? '', {
                keys: ['name'],
            }) ?? [];
        if (exclude) {
            return result.filter(p => !exclude(p.id));
        }
        return result;
    });

    return {
        packages: state,
        isLoadingPackages: isLoading,
        refreshPackages: execute,
        packagesFilter,
        filteredPackages,
    };
};
